import { default as applyYpFtKnoqTPMeta } from "/codebuild/output/src423944966/src/pages/apply-creator/apply.vue?macro=true";
import { default as index3vRBx8R8fVMeta } from "/codebuild/output/src423944966/src/pages/apply-creator/index.vue?macro=true";
import { default as formkI2NQHOnBHMeta } from "/codebuild/output/src423944966/src/pages/apply-dao/form.vue?macro=true";
import { default as indexLqFdzsMt8MMeta } from "/codebuild/output/src423944966/src/pages/apply-dao/index.vue?macro=true";
import { default as form0VnF2viiAQMeta } from "/codebuild/output/src423944966/src/pages/apply-kpop-cover-dance/form.vue?macro=true";
import { default as additionalawIE8ALuV9Meta } from "/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/additional.vue?macro=true";
import { default as completeByEYRK1cWyMeta } from "/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/complete.vue?macro=true";
import { default as indexJXW99DlgtuMeta } from "/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/index.vue?macro=true";
import { default as index9KWJfSwgyeMeta } from "/codebuild/output/src423944966/src/pages/apply-rent/index.vue?macro=true";
import { default as form7SF9qO5rIjMeta } from "/codebuild/output/src423944966/src/pages/apply-super-moon/form.vue?macro=true";
import { default as indexxLyeo1kwx8Meta } from "/codebuild/output/src423944966/src/pages/apply-super-moon/index.vue?macro=true";
import { default as _91id_93d4s6nYhmX8Meta } from "/codebuild/output/src423944966/src/pages/board/event/[id].vue?macro=true";
import { default as indexu49CqBopK0Meta } from "/codebuild/output/src423944966/src/pages/board/event/index.vue?macro=true";
import { default as _91id_93EH37RlfBFTMeta } from "/codebuild/output/src423944966/src/pages/board/faq/[id].vue?macro=true";
import { default as index6wU91pJsriMeta } from "/codebuild/output/src423944966/src/pages/board/faq/index.vue?macro=true";
import { default as _91id_93GzrLT5pP60Meta } from "/codebuild/output/src423944966/src/pages/board/news/[id].vue?macro=true";
import { default as indexN6bTTGg8swMeta } from "/codebuild/output/src423944966/src/pages/board/news/index.vue?macro=true";
import { default as _91id_93IJ0NefdoiuMeta } from "/codebuild/output/src423944966/src/pages/board/notice/[id].vue?macro=true";
import { default as indexDX3JKzVdvKMeta } from "/codebuild/output/src423944966/src/pages/board/notice/index.vue?macro=true";
import { default as pay7RkbUenFrPMeta } from "/codebuild/output/src423944966/src/pages/callback/pay.vue?macro=true";
import { default as signinrqZJNEdzjKMeta } from "/codebuild/output/src423944966/src/pages/callback/signin.vue?macro=true";
import { default as signupqbWURjpMJ1Meta } from "/codebuild/output/src423944966/src/pages/callback/signup.vue?macro=true";
import { default as indexKZtn5NgxWjMeta } from "/codebuild/output/src423944966/src/pages/chatbot/[uuid]/index.vue?macro=true";
import { default as _91postId_93D4DDUuozPkMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/activities/[postId].vue?macro=true";
import { default as activitiesr52inwAAHDMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/activities.vue?macro=true";
import { default as _91collectionId_93VRpMpk1JKuMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/collections/[collectionId].vue?macro=true";
import { default as collectionsapcd9gpWUzMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/collections.vue?macro=true";
import { default as _91daoPostId_936LedC8gxtHMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/dao/board/[daoPostId].vue?macro=true";
import { default as index5uBTFeOPQTMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/dao/board/index.vue?macro=true";
import { default as indexfglNfClONpMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/dao/index.vue?macro=true";
import { default as memberxPrCeOgj70Meta } from "/codebuild/output/src423944966/src/pages/creator/[id]/dao/member.vue?macro=true";
import { default as _91voteId_93cv5RhLrGyGMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/dao/vote/[voteId].vue?macro=true";
import { default as votewRx9bPb4WVMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/dao/vote.vue?macro=true";
import { default as donationAHcgVbep52Meta } from "/codebuild/output/src423944966/src/pages/creator/[id]/donation.vue?macro=true";
import { default as guestbookLG0wdDVqfyMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/guestbook.vue?macro=true";
import { default as _91postId_93itLctgF7TmMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/index/[postId].vue?macro=true";
import { default as index3Xs7hyob7DMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/index.vue?macro=true";
import { default as _91noticeId_93V3UlwKjHSkMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/notice/[noticeId].vue?macro=true";
import { default as noticeltbxxl0V00Meta } from "/codebuild/output/src423944966/src/pages/creator/[id]/notice.vue?macro=true";
import { default as _91postId_93aSOL5FXZF7Meta } from "/codebuild/output/src423944966/src/pages/creator/[id]/nova-plus/[postId].vue?macro=true";
import { default as index13FKFLWUe1Meta } from "/codebuild/output/src423944966/src/pages/creator/[id]/nova-plus/index.vue?macro=true";
import { default as _91postId_93d9cBdPtOkDMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/posts/[postId].vue?macro=true";
import { default as index4eYEvTslF7Meta } from "/codebuild/output/src423944966/src/pages/creator/[id]/posts/index.vue?macro=true";
import { default as rewardBm0YGg6KlSMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/reward.vue?macro=true";
import { default as statistics5h0kt0J9jjMeta } from "/codebuild/output/src423944966/src/pages/creator/[id]/statistics.vue?macro=true";
import { default as sponsors7NqhnSes0KMeta } from "/codebuild/output/src423944966/src/pages/creator/sponsors.vue?macro=true";
import { default as _91creatorUserSn_93weaCQFwMedMeta } from "/codebuild/output/src423944966/src/pages/creator/subscribe/cancel/[creatorUserSn].vue?macro=true";
import { default as _91creatorUserSn_93jNHRYv0OFpMeta } from "/codebuild/output/src423944966/src/pages/creator/subscribe/opened/[creatorUserSn].vue?macro=true";
import { default as _91creatorUserSn_93ywqPFJVYzyMeta } from "/codebuild/output/src423944966/src/pages/creator/subscribe/refund/[creatorUserSn].vue?macro=true";
import { default as _91creatorUserSn_93Eld3YFkDFNMeta } from "/codebuild/output/src423944966/src/pages/creator/subscribe/support/[creatorUserSn].vue?macro=true";
import { default as allv9Rr8WueTXMeta } from "/codebuild/output/src423944966/src/pages/creators/all.vue?macro=true";
import { default as mye5pzOAapOfMeta } from "/codebuild/output/src423944966/src/pages/creators/my.vue?macro=true";
import { default as indexBMf2kaoGHFMeta } from "/codebuild/output/src423944966/src/pages/daily-check/index.vue?macro=true";
import { default as _91id_93TCpirnM4GHMeta } from "/codebuild/output/src423944966/src/pages/feed/[id].vue?macro=true";
import { default as index6PhxdstkDPMeta } from "/codebuild/output/src423944966/src/pages/feed/index.vue?macro=true";
import { default as indexGo8QZhSo9kMeta } from "/codebuild/output/src423944966/src/pages/fund/gaudi-fund/index.vue?macro=true";
import { default as gaudidsgGBVy6ehMeta } from "/codebuild/output/src423944966/src/pages/fund/gaudi.vue?macro=true";
import { default as _91id_93wh4RxvPGleMeta } from "/codebuild/output/src423944966/src/pages/fund/history/[id].vue?macro=true";
import { default as historywsLh82s6cUMeta } from "/codebuild/output/src423944966/src/pages/fund/history.vue?macro=true";
import { default as _91id_93H0VEd0eb6YMeta } from "/codebuild/output/src423944966/src/pages/fund/index/[id].vue?macro=true";
import { default as index9QotyrkZlBMeta } from "/codebuild/output/src423944966/src/pages/fund/index.vue?macro=true";
import { default as _91id_93N5D0YMVmeWMeta } from "/codebuild/output/src423944966/src/pages/fund/notice/[id].vue?macro=true";
import { default as index1vI4lQtunWMeta } from "/codebuild/output/src423944966/src/pages/fund/notice/index.vue?macro=true";
import { default as _91id_93lQoq2T9LyCMeta } from "/codebuild/output/src423944966/src/pages/hashtag/[id].vue?macro=true";
import { default as indexjQ50CX4jCBMeta } from "/codebuild/output/src423944966/src/pages/hashtag/index.vue?macro=true";
import { default as indexy4F4jEertZMeta } from "/codebuild/output/src423944966/src/pages/index.vue?macro=true";
import { default as _91id_93fFlgrn9oEhMeta } from "/codebuild/output/src423944966/src/pages/nova-plus/[id].vue?macro=true";
import { default as index7hLDESftgZMeta } from "/codebuild/output/src423944966/src/pages/nova-plus/index.vue?macro=true";
import { default as indexCHTWu3LHyUMeta } from "/codebuild/output/src423944966/src/pages/oulim/index.vue?macro=true";
import { default as _91id_93WoBc8bOIqZMeta } from "/codebuild/output/src423944966/src/pages/post/[id].vue?macro=true";
import { default as _64_91id_933Y4ceXmaJwMeta } from "/codebuild/output/src423944966/src/pages/referral/@[id].vue?macro=true";
import { default as _91id_93Lvotf1nEuyMeta } from "/codebuild/output/src423944966/src/pages/search/detail/comment/[id].vue?macro=true";
import { default as indexK0tlu3JdQzMeta } from "/codebuild/output/src423944966/src/pages/search/detail/comment/index.vue?macro=true";
import { default as hashtag57jddELMijMeta } from "/codebuild/output/src423944966/src/pages/search/detail/hashtag.vue?macro=true";
import { default as _91id_93pRTRcM88nAMeta } from "/codebuild/output/src423944966/src/pages/search/detail/index/[id].vue?macro=true";
import { default as indexns34CPQrlbMeta } from "/codebuild/output/src423944966/src/pages/search/detail/index/index.vue?macro=true";
import { default as _91id_93dK2Y1VBKZZMeta } from "/codebuild/output/src423944966/src/pages/search/detail/nova-plus/[id].vue?macro=true";
import { default as indexnJ1xH9qc8kMeta } from "/codebuild/output/src423944966/src/pages/search/detail/nova-plus/index.vue?macro=true";
import { default as userOEFf9gfaykMeta } from "/codebuild/output/src423944966/src/pages/search/detail/user.vue?macro=true";
import { default as _91id_93EbBweYqwhMMeta } from "/codebuild/output/src423944966/src/pages/search/index/[id].vue?macro=true";
import { default as index4UCIMGq1raMeta } from "/codebuild/output/src423944966/src/pages/search/index.vue?macro=true";
import { default as _91id_937WHYmxus8RMeta } from "/codebuild/output/src423944966/src/pages/terms/[id].vue?macro=true";
import { default as _91postId_93mDoG5nJ8WkMeta } from "/codebuild/output/src423944966/src/pages/user/[id]/activities/[postId].vue?macro=true";
import { default as activitiesNcpdNbVdnAMeta } from "/codebuild/output/src423944966/src/pages/user/[id]/activities.vue?macro=true";
import { default as _91collectionId_93dLOPgoEfPcMeta } from "/codebuild/output/src423944966/src/pages/user/[id]/collections/[collectionId].vue?macro=true";
import { default as collectionswG6281hYg9Meta } from "/codebuild/output/src423944966/src/pages/user/[id]/collections.vue?macro=true";
import { default as donationqQj8ypW8bIMeta } from "/codebuild/output/src423944966/src/pages/user/[id]/donation.vue?macro=true";
import { default as _91postId_93PWjT0iMFzWMeta } from "/codebuild/output/src423944966/src/pages/user/[id]/index/[postId].vue?macro=true";
import { default as indexDI5ksVrwpHMeta } from "/codebuild/output/src423944966/src/pages/user/[id]/index/index.vue?macro=true";
import { default as reward2vI28LPZfAMeta } from "/codebuild/output/src423944966/src/pages/user/[id]/reward.vue?macro=true";
import { default as indexCfqUhDzDBhMeta } from "/codebuild/output/src423944966/src/pages/user/sponsors/index.vue?macro=true";
import { default as _91id_93aUgOkUFBS8Meta } from "/codebuild/output/src423944966/src/pages/w3cf/detail/[id].vue?macro=true";
import { default as indexUvIOAGE16nMeta } from "/codebuild/output/src423944966/src/pages/w3cf/index.vue?macro=true";
export default [
  {
    name: "apply-creator-apply___ko",
    path: "/apply-creator/apply",
    meta: applyYpFtKnoqTPMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-creator/apply.vue")
  },
  {
    name: "apply-creator-apply___en",
    path: "/en/apply-creator/apply",
    meta: applyYpFtKnoqTPMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-creator/apply.vue")
  },
  {
    name: "apply-creator-apply___th",
    path: "/th/apply-creator/apply",
    meta: applyYpFtKnoqTPMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-creator/apply.vue")
  },
  {
    name: "apply-creator___ko",
    path: "/apply-creator",
    meta: index3vRBx8R8fVMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-creator/index.vue")
  },
  {
    name: "apply-creator___en",
    path: "/en/apply-creator",
    meta: index3vRBx8R8fVMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-creator/index.vue")
  },
  {
    name: "apply-creator___th",
    path: "/th/apply-creator",
    meta: index3vRBx8R8fVMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-creator/index.vue")
  },
  {
    name: "apply-dao-form___ko",
    path: "/apply-dao/form",
    meta: formkI2NQHOnBHMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-dao/form.vue")
  },
  {
    name: "apply-dao-form___en",
    path: "/en/apply-dao/form",
    meta: formkI2NQHOnBHMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-dao/form.vue")
  },
  {
    name: "apply-dao-form___th",
    path: "/th/apply-dao/form",
    meta: formkI2NQHOnBHMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-dao/form.vue")
  },
  {
    name: "apply-dao___ko",
    path: "/apply-dao",
    meta: indexLqFdzsMt8MMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-dao/index.vue")
  },
  {
    name: "apply-dao___en",
    path: "/en/apply-dao",
    meta: indexLqFdzsMt8MMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-dao/index.vue")
  },
  {
    name: "apply-dao___th",
    path: "/th/apply-dao",
    meta: indexLqFdzsMt8MMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-dao/index.vue")
  },
  {
    name: "apply-kpop-cover-dance-form___ko",
    path: "/apply-kpop-cover-dance/form",
    meta: form0VnF2viiAQMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-kpop-cover-dance/form.vue")
  },
  {
    name: "apply-kpop-cover-dance-form___en",
    path: "/en/apply-kpop-cover-dance/form",
    meta: form0VnF2viiAQMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-kpop-cover-dance/form.vue")
  },
  {
    name: "apply-kpop-cover-dance-form___th",
    path: "/th/apply-kpop-cover-dance/form",
    meta: form0VnF2viiAQMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-kpop-cover-dance/form.vue")
  },
  {
    name: "apply-rent-facility-id-additional___ko",
    path: "/apply-rent/facility-:id()/additional",
    meta: additionalawIE8ALuV9Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/additional.vue")
  },
  {
    name: "apply-rent-facility-id-additional___en",
    path: "/en/apply-rent/facility-:id()/additional",
    meta: additionalawIE8ALuV9Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/additional.vue")
  },
  {
    name: "apply-rent-facility-id-additional___th",
    path: "/th/apply-rent/facility-:id()/additional",
    meta: additionalawIE8ALuV9Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/additional.vue")
  },
  {
    name: "apply-rent-facility-id-complete___ko",
    path: "/apply-rent/facility-:id()/complete",
    meta: completeByEYRK1cWyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/complete.vue")
  },
  {
    name: "apply-rent-facility-id-complete___en",
    path: "/en/apply-rent/facility-:id()/complete",
    meta: completeByEYRK1cWyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/complete.vue")
  },
  {
    name: "apply-rent-facility-id-complete___th",
    path: "/th/apply-rent/facility-:id()/complete",
    meta: completeByEYRK1cWyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/complete.vue")
  },
  {
    name: "apply-rent-facility-id___ko",
    path: "/apply-rent/facility-:id()",
    meta: indexJXW99DlgtuMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/index.vue")
  },
  {
    name: "apply-rent-facility-id___en",
    path: "/en/apply-rent/facility-:id()",
    meta: indexJXW99DlgtuMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/index.vue")
  },
  {
    name: "apply-rent-facility-id___th",
    path: "/th/apply-rent/facility-:id()",
    meta: indexJXW99DlgtuMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/facility-[id]/index.vue")
  },
  {
    name: "apply-rent___ko",
    path: "/apply-rent",
    meta: index9KWJfSwgyeMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/index.vue")
  },
  {
    name: "apply-rent___en",
    path: "/en/apply-rent",
    meta: index9KWJfSwgyeMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/index.vue")
  },
  {
    name: "apply-rent___th",
    path: "/th/apply-rent",
    meta: index9KWJfSwgyeMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-rent/index.vue")
  },
  {
    name: "apply-super-moon-form___ko",
    path: "/apply-super-moon/form",
    meta: form7SF9qO5rIjMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-super-moon/form.vue")
  },
  {
    name: "apply-super-moon-form___en",
    path: "/en/apply-super-moon/form",
    meta: form7SF9qO5rIjMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-super-moon/form.vue")
  },
  {
    name: "apply-super-moon-form___th",
    path: "/th/apply-super-moon/form",
    meta: form7SF9qO5rIjMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-super-moon/form.vue")
  },
  {
    name: "apply-super-moon___ko",
    path: "/apply-super-moon",
    meta: indexxLyeo1kwx8Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-super-moon/index.vue")
  },
  {
    name: "apply-super-moon___en",
    path: "/en/apply-super-moon",
    meta: indexxLyeo1kwx8Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-super-moon/index.vue")
  },
  {
    name: "apply-super-moon___th",
    path: "/th/apply-super-moon",
    meta: indexxLyeo1kwx8Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/apply-super-moon/index.vue")
  },
  {
    name: "board-event-id___ko",
    path: "/board/event/:id()",
    meta: _91id_93d4s6nYhmX8Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/event/[id].vue")
  },
  {
    name: "board-event-id___en",
    path: "/en/board/event/:id()",
    meta: _91id_93d4s6nYhmX8Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/event/[id].vue")
  },
  {
    name: "board-event-id___th",
    path: "/th/board/event/:id()",
    meta: _91id_93d4s6nYhmX8Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/event/[id].vue")
  },
  {
    name: "board-event___ko",
    path: "/board/event",
    meta: indexu49CqBopK0Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/event/index.vue")
  },
  {
    name: "board-event___en",
    path: "/en/board/event",
    meta: indexu49CqBopK0Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/event/index.vue")
  },
  {
    name: "board-event___th",
    path: "/th/board/event",
    meta: indexu49CqBopK0Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/event/index.vue")
  },
  {
    name: "board-faq-id___ko",
    path: "/board/faq/:id()",
    meta: _91id_93EH37RlfBFTMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/faq/[id].vue")
  },
  {
    name: "board-faq-id___en",
    path: "/en/board/faq/:id()",
    meta: _91id_93EH37RlfBFTMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/faq/[id].vue")
  },
  {
    name: "board-faq-id___th",
    path: "/th/board/faq/:id()",
    meta: _91id_93EH37RlfBFTMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/faq/[id].vue")
  },
  {
    name: "board-faq___ko",
    path: "/board/faq",
    meta: index6wU91pJsriMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/faq/index.vue")
  },
  {
    name: "board-faq___en",
    path: "/en/board/faq",
    meta: index6wU91pJsriMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/faq/index.vue")
  },
  {
    name: "board-faq___th",
    path: "/th/board/faq",
    meta: index6wU91pJsriMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/faq/index.vue")
  },
  {
    name: "board-news-id___ko",
    path: "/board/news/:id()",
    meta: _91id_93GzrLT5pP60Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/news/[id].vue")
  },
  {
    name: "board-news-id___en",
    path: "/en/board/news/:id()",
    meta: _91id_93GzrLT5pP60Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/news/[id].vue")
  },
  {
    name: "board-news-id___th",
    path: "/th/board/news/:id()",
    meta: _91id_93GzrLT5pP60Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/news/[id].vue")
  },
  {
    name: "board-news___ko",
    path: "/board/news",
    meta: indexN6bTTGg8swMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/news/index.vue")
  },
  {
    name: "board-news___en",
    path: "/en/board/news",
    meta: indexN6bTTGg8swMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/news/index.vue")
  },
  {
    name: "board-news___th",
    path: "/th/board/news",
    meta: indexN6bTTGg8swMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/news/index.vue")
  },
  {
    name: "board-notice-id___ko",
    path: "/board/notice/:id()",
    meta: _91id_93IJ0NefdoiuMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/notice/[id].vue")
  },
  {
    name: "board-notice-id___en",
    path: "/en/board/notice/:id()",
    meta: _91id_93IJ0NefdoiuMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/notice/[id].vue")
  },
  {
    name: "board-notice-id___th",
    path: "/th/board/notice/:id()",
    meta: _91id_93IJ0NefdoiuMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/notice/[id].vue")
  },
  {
    name: "board-notice___ko",
    path: "/board/notice",
    meta: indexDX3JKzVdvKMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/notice/index.vue")
  },
  {
    name: "board-notice___en",
    path: "/en/board/notice",
    meta: indexDX3JKzVdvKMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/notice/index.vue")
  },
  {
    name: "board-notice___th",
    path: "/th/board/notice",
    meta: indexDX3JKzVdvKMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/board/notice/index.vue")
  },
  {
    name: "callback-pay___ko",
    path: "/callback/pay",
    meta: pay7RkbUenFrPMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/callback/pay.vue")
  },
  {
    name: "callback-pay___en",
    path: "/en/callback/pay",
    meta: pay7RkbUenFrPMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/callback/pay.vue")
  },
  {
    name: "callback-pay___th",
    path: "/th/callback/pay",
    meta: pay7RkbUenFrPMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/callback/pay.vue")
  },
  {
    name: "callback-signin___ko",
    path: "/callback/signin",
    meta: signinrqZJNEdzjKMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/callback/signin.vue")
  },
  {
    name: "callback-signin___en",
    path: "/en/callback/signin",
    meta: signinrqZJNEdzjKMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/callback/signin.vue")
  },
  {
    name: "callback-signin___th",
    path: "/th/callback/signin",
    meta: signinrqZJNEdzjKMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/callback/signin.vue")
  },
  {
    name: "callback-signup___ko",
    path: "/callback/signup",
    meta: signupqbWURjpMJ1Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/callback/signup.vue")
  },
  {
    name: "callback-signup___en",
    path: "/en/callback/signup",
    meta: signupqbWURjpMJ1Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/callback/signup.vue")
  },
  {
    name: "callback-signup___th",
    path: "/th/callback/signup",
    meta: signupqbWURjpMJ1Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/callback/signup.vue")
  },
  {
    name: "chatbot-uuid___ko",
    path: "/chatbot/:uuid()",
    meta: indexKZtn5NgxWjMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/chatbot/[uuid]/index.vue")
  },
  {
    name: "chatbot-uuid___en",
    path: "/en/chatbot/:uuid()",
    meta: indexKZtn5NgxWjMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/chatbot/[uuid]/index.vue")
  },
  {
    name: "chatbot-uuid___th",
    path: "/th/chatbot/:uuid()",
    meta: indexKZtn5NgxWjMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/chatbot/[uuid]/index.vue")
  },
  {
    name: "creator-id-activities___ko",
    path: "/creator/:id()/activities",
    meta: activitiesr52inwAAHDMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/activities.vue"),
    children: [
  {
    name: "creator-id-activities-postId___ko",
    path: ":postId()",
    meta: _91postId_93D4DDUuozPkMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/activities/[postId].vue")
  }
]
  },
  {
    name: "creator-id-activities___en",
    path: "/en/creator/:id()/activities",
    meta: activitiesr52inwAAHDMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/activities.vue"),
    children: [
  {
    name: "creator-id-activities-postId___en",
    path: ":postId()",
    meta: _91postId_93D4DDUuozPkMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/activities/[postId].vue")
  }
]
  },
  {
    name: "creator-id-activities___th",
    path: "/th/creator/:id()/activities",
    meta: activitiesr52inwAAHDMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/activities.vue"),
    children: [
  {
    name: "creator-id-activities-postId___th",
    path: ":postId()",
    meta: _91postId_93D4DDUuozPkMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/activities/[postId].vue")
  }
]
  },
  {
    name: "creator-id-collections___ko",
    path: "/creator/:id()/collections",
    meta: collectionsapcd9gpWUzMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/collections.vue"),
    children: [
  {
    name: "creator-id-collections-collectionId___ko",
    path: ":collectionId()",
    meta: _91collectionId_93VRpMpk1JKuMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/collections/[collectionId].vue")
  }
]
  },
  {
    name: "creator-id-collections___en",
    path: "/en/creator/:id()/collections",
    meta: collectionsapcd9gpWUzMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/collections.vue"),
    children: [
  {
    name: "creator-id-collections-collectionId___en",
    path: ":collectionId()",
    meta: _91collectionId_93VRpMpk1JKuMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/collections/[collectionId].vue")
  }
]
  },
  {
    name: "creator-id-collections___th",
    path: "/th/creator/:id()/collections",
    meta: collectionsapcd9gpWUzMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/collections.vue"),
    children: [
  {
    name: "creator-id-collections-collectionId___th",
    path: ":collectionId()",
    meta: _91collectionId_93VRpMpk1JKuMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/collections/[collectionId].vue")
  }
]
  },
  {
    name: "creator-id-dao-board-daoPostId___ko",
    path: "/creator/:id()/dao/board/:daoPostId()",
    meta: _91daoPostId_936LedC8gxtHMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/board/[daoPostId].vue")
  },
  {
    name: "creator-id-dao-board-daoPostId___en",
    path: "/en/creator/:id()/dao/board/:daoPostId()",
    meta: _91daoPostId_936LedC8gxtHMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/board/[daoPostId].vue")
  },
  {
    name: "creator-id-dao-board-daoPostId___th",
    path: "/th/creator/:id()/dao/board/:daoPostId()",
    meta: _91daoPostId_936LedC8gxtHMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/board/[daoPostId].vue")
  },
  {
    name: "creator-id-dao-board___ko",
    path: "/creator/:id()/dao/board",
    meta: index5uBTFeOPQTMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/board/index.vue")
  },
  {
    name: "creator-id-dao-board___en",
    path: "/en/creator/:id()/dao/board",
    meta: index5uBTFeOPQTMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/board/index.vue")
  },
  {
    name: "creator-id-dao-board___th",
    path: "/th/creator/:id()/dao/board",
    meta: index5uBTFeOPQTMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/board/index.vue")
  },
  {
    name: "creator-id-dao___ko",
    path: "/creator/:id()/dao",
    meta: indexfglNfClONpMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/index.vue")
  },
  {
    name: "creator-id-dao___en",
    path: "/en/creator/:id()/dao",
    meta: indexfglNfClONpMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/index.vue")
  },
  {
    name: "creator-id-dao___th",
    path: "/th/creator/:id()/dao",
    meta: indexfglNfClONpMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/index.vue")
  },
  {
    name: "creator-id-dao-member___ko",
    path: "/creator/:id()/dao/member",
    meta: memberxPrCeOgj70Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/member.vue")
  },
  {
    name: "creator-id-dao-member___en",
    path: "/en/creator/:id()/dao/member",
    meta: memberxPrCeOgj70Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/member.vue")
  },
  {
    name: "creator-id-dao-member___th",
    path: "/th/creator/:id()/dao/member",
    meta: memberxPrCeOgj70Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/member.vue")
  },
  {
    name: "creator-id-dao-vote___ko",
    path: "/creator/:id()/dao/vote",
    meta: votewRx9bPb4WVMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/vote.vue"),
    children: [
  {
    name: "creator-id-dao-vote-voteId___ko",
    path: ":voteId()",
    meta: _91voteId_93cv5RhLrGyGMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/vote/[voteId].vue")
  }
]
  },
  {
    name: "creator-id-dao-vote___en",
    path: "/en/creator/:id()/dao/vote",
    meta: votewRx9bPb4WVMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/vote.vue"),
    children: [
  {
    name: "creator-id-dao-vote-voteId___en",
    path: ":voteId()",
    meta: _91voteId_93cv5RhLrGyGMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/vote/[voteId].vue")
  }
]
  },
  {
    name: "creator-id-dao-vote___th",
    path: "/th/creator/:id()/dao/vote",
    meta: votewRx9bPb4WVMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/vote.vue"),
    children: [
  {
    name: "creator-id-dao-vote-voteId___th",
    path: ":voteId()",
    meta: _91voteId_93cv5RhLrGyGMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/dao/vote/[voteId].vue")
  }
]
  },
  {
    name: "creator-id-donation___ko",
    path: "/creator/:id()/donation",
    meta: donationAHcgVbep52Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/donation.vue")
  },
  {
    name: "creator-id-donation___en",
    path: "/en/creator/:id()/donation",
    meta: donationAHcgVbep52Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/donation.vue")
  },
  {
    name: "creator-id-donation___th",
    path: "/th/creator/:id()/donation",
    meta: donationAHcgVbep52Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/donation.vue")
  },
  {
    name: "creator-id-guestbook___ko",
    path: "/creator/:id()/guestbook",
    meta: guestbookLG0wdDVqfyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/guestbook.vue")
  },
  {
    name: "creator-id-guestbook___en",
    path: "/en/creator/:id()/guestbook",
    meta: guestbookLG0wdDVqfyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/guestbook.vue")
  },
  {
    name: "creator-id-guestbook___th",
    path: "/th/creator/:id()/guestbook",
    meta: guestbookLG0wdDVqfyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/guestbook.vue")
  },
  {
    name: "creator-id___ko",
    path: "/creator/:id()",
    meta: index3Xs7hyob7DMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/index.vue"),
    children: [
  {
    name: "creator-id-index-postId___ko",
    path: ":postId()",
    meta: _91postId_93itLctgF7TmMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/index/[postId].vue")
  }
]
  },
  {
    name: "creator-id___en",
    path: "/en/creator/:id()",
    meta: index3Xs7hyob7DMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/index.vue"),
    children: [
  {
    name: "creator-id-index-postId___en",
    path: ":postId()",
    meta: _91postId_93itLctgF7TmMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/index/[postId].vue")
  }
]
  },
  {
    name: "creator-id___th",
    path: "/th/creator/:id()",
    meta: index3Xs7hyob7DMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/index.vue"),
    children: [
  {
    name: "creator-id-index-postId___th",
    path: ":postId()",
    meta: _91postId_93itLctgF7TmMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/index/[postId].vue")
  }
]
  },
  {
    name: "creator-id-notice___ko",
    path: "/creator/:id()/notice",
    meta: noticeltbxxl0V00Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/notice.vue"),
    children: [
  {
    name: "creator-id-notice-noticeId___ko",
    path: ":noticeId()",
    meta: _91noticeId_93V3UlwKjHSkMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/notice/[noticeId].vue")
  }
]
  },
  {
    name: "creator-id-notice___en",
    path: "/en/creator/:id()/notice",
    meta: noticeltbxxl0V00Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/notice.vue"),
    children: [
  {
    name: "creator-id-notice-noticeId___en",
    path: ":noticeId()",
    meta: _91noticeId_93V3UlwKjHSkMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/notice/[noticeId].vue")
  }
]
  },
  {
    name: "creator-id-notice___th",
    path: "/th/creator/:id()/notice",
    meta: noticeltbxxl0V00Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/notice.vue"),
    children: [
  {
    name: "creator-id-notice-noticeId___th",
    path: ":noticeId()",
    meta: _91noticeId_93V3UlwKjHSkMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/notice/[noticeId].vue")
  }
]
  },
  {
    name: "creator-id-nova-plus-postId___ko",
    path: "/creator/:id()/nova-plus/:postId()",
    meta: _91postId_93aSOL5FXZF7Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/nova-plus/[postId].vue")
  },
  {
    name: "creator-id-nova-plus-postId___en",
    path: "/en/creator/:id()/nova-plus/:postId()",
    meta: _91postId_93aSOL5FXZF7Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/nova-plus/[postId].vue")
  },
  {
    name: "creator-id-nova-plus-postId___th",
    path: "/th/creator/:id()/nova-plus/:postId()",
    meta: _91postId_93aSOL5FXZF7Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/nova-plus/[postId].vue")
  },
  {
    name: "creator-id-nova-plus___ko",
    path: "/creator/:id()/nova-plus",
    meta: index13FKFLWUe1Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/nova-plus/index.vue")
  },
  {
    name: "creator-id-nova-plus___en",
    path: "/en/creator/:id()/nova-plus",
    meta: index13FKFLWUe1Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/nova-plus/index.vue")
  },
  {
    name: "creator-id-nova-plus___th",
    path: "/th/creator/:id()/nova-plus",
    meta: index13FKFLWUe1Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/nova-plus/index.vue")
  },
  {
    name: "creator-id-posts-postId___ko",
    path: "/creator/:id()/posts/:postId()",
    meta: _91postId_93d9cBdPtOkDMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/posts/[postId].vue")
  },
  {
    name: "creator-id-posts-postId___en",
    path: "/en/creator/:id()/posts/:postId()",
    meta: _91postId_93d9cBdPtOkDMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/posts/[postId].vue")
  },
  {
    name: "creator-id-posts-postId___th",
    path: "/th/creator/:id()/posts/:postId()",
    meta: _91postId_93d9cBdPtOkDMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/posts/[postId].vue")
  },
  {
    name: "creator-id-posts___ko",
    path: "/creator/:id()/posts",
    meta: index4eYEvTslF7Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/posts/index.vue")
  },
  {
    name: "creator-id-posts___en",
    path: "/en/creator/:id()/posts",
    meta: index4eYEvTslF7Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/posts/index.vue")
  },
  {
    name: "creator-id-posts___th",
    path: "/th/creator/:id()/posts",
    meta: index4eYEvTslF7Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/posts/index.vue")
  },
  {
    name: "creator-id-reward___ko",
    path: "/creator/:id()/reward",
    meta: rewardBm0YGg6KlSMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/reward.vue")
  },
  {
    name: "creator-id-reward___en",
    path: "/en/creator/:id()/reward",
    meta: rewardBm0YGg6KlSMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/reward.vue")
  },
  {
    name: "creator-id-reward___th",
    path: "/th/creator/:id()/reward",
    meta: rewardBm0YGg6KlSMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/reward.vue")
  },
  {
    name: "creator-id-statistics___ko",
    path: "/creator/:id()/statistics",
    meta: statistics5h0kt0J9jjMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/statistics.vue")
  },
  {
    name: "creator-id-statistics___en",
    path: "/en/creator/:id()/statistics",
    meta: statistics5h0kt0J9jjMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/statistics.vue")
  },
  {
    name: "creator-id-statistics___th",
    path: "/th/creator/:id()/statistics",
    meta: statistics5h0kt0J9jjMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/[id]/statistics.vue")
  },
  {
    name: "creator-sponsors___ko",
    path: "/creator/sponsors",
    meta: sponsors7NqhnSes0KMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/sponsors.vue")
  },
  {
    name: "creator-sponsors___en",
    path: "/en/creator/sponsors",
    meta: sponsors7NqhnSes0KMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/sponsors.vue")
  },
  {
    name: "creator-sponsors___th",
    path: "/th/creator/sponsors",
    meta: sponsors7NqhnSes0KMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/sponsors.vue")
  },
  {
    name: "creator-subscribe-cancel-creatorUserSn___ko",
    path: "/creator/subscribe/cancel/:creatorUserSn()",
    meta: _91creatorUserSn_93weaCQFwMedMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/cancel/[creatorUserSn].vue")
  },
  {
    name: "creator-subscribe-cancel-creatorUserSn___en",
    path: "/en/creator/subscribe/cancel/:creatorUserSn()",
    meta: _91creatorUserSn_93weaCQFwMedMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/cancel/[creatorUserSn].vue")
  },
  {
    name: "creator-subscribe-cancel-creatorUserSn___th",
    path: "/th/creator/subscribe/cancel/:creatorUserSn()",
    meta: _91creatorUserSn_93weaCQFwMedMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/cancel/[creatorUserSn].vue")
  },
  {
    name: "creator-subscribe-opened-creatorUserSn___ko",
    path: "/creator/subscribe/opened/:creatorUserSn()",
    meta: _91creatorUserSn_93jNHRYv0OFpMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/opened/[creatorUserSn].vue")
  },
  {
    name: "creator-subscribe-opened-creatorUserSn___en",
    path: "/en/creator/subscribe/opened/:creatorUserSn()",
    meta: _91creatorUserSn_93jNHRYv0OFpMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/opened/[creatorUserSn].vue")
  },
  {
    name: "creator-subscribe-opened-creatorUserSn___th",
    path: "/th/creator/subscribe/opened/:creatorUserSn()",
    meta: _91creatorUserSn_93jNHRYv0OFpMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/opened/[creatorUserSn].vue")
  },
  {
    name: "creator-subscribe-refund-creatorUserSn___ko",
    path: "/creator/subscribe/refund/:creatorUserSn()",
    meta: _91creatorUserSn_93ywqPFJVYzyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/refund/[creatorUserSn].vue")
  },
  {
    name: "creator-subscribe-refund-creatorUserSn___en",
    path: "/en/creator/subscribe/refund/:creatorUserSn()",
    meta: _91creatorUserSn_93ywqPFJVYzyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/refund/[creatorUserSn].vue")
  },
  {
    name: "creator-subscribe-refund-creatorUserSn___th",
    path: "/th/creator/subscribe/refund/:creatorUserSn()",
    meta: _91creatorUserSn_93ywqPFJVYzyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/refund/[creatorUserSn].vue")
  },
  {
    name: "creator-subscribe-support-creatorUserSn___ko",
    path: "/creator/subscribe/support/:creatorUserSn()",
    meta: _91creatorUserSn_93Eld3YFkDFNMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/support/[creatorUserSn].vue")
  },
  {
    name: "creator-subscribe-support-creatorUserSn___en",
    path: "/en/creator/subscribe/support/:creatorUserSn()",
    meta: _91creatorUserSn_93Eld3YFkDFNMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/support/[creatorUserSn].vue")
  },
  {
    name: "creator-subscribe-support-creatorUserSn___th",
    path: "/th/creator/subscribe/support/:creatorUserSn()",
    meta: _91creatorUserSn_93Eld3YFkDFNMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creator/subscribe/support/[creatorUserSn].vue")
  },
  {
    name: "creators-all___ko",
    path: "/creators/all",
    meta: allv9Rr8WueTXMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creators/all.vue")
  },
  {
    name: "creators-all___en",
    path: "/en/creators/all",
    meta: allv9Rr8WueTXMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creators/all.vue")
  },
  {
    name: "creators-all___th",
    path: "/th/creators/all",
    meta: allv9Rr8WueTXMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creators/all.vue")
  },
  {
    name: "creators-my___ko",
    path: "/creators/my",
    meta: mye5pzOAapOfMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creators/my.vue")
  },
  {
    name: "creators-my___en",
    path: "/en/creators/my",
    meta: mye5pzOAapOfMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creators/my.vue")
  },
  {
    name: "creators-my___th",
    path: "/th/creators/my",
    meta: mye5pzOAapOfMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/creators/my.vue")
  },
  {
    name: "daily-check___ko",
    path: "/daily-check",
    meta: indexBMf2kaoGHFMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/daily-check/index.vue")
  },
  {
    name: "daily-check___en",
    path: "/en/daily-check",
    meta: indexBMf2kaoGHFMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/daily-check/index.vue")
  },
  {
    name: "daily-check___th",
    path: "/th/daily-check",
    meta: indexBMf2kaoGHFMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/daily-check/index.vue")
  },
  {
    name: "feed-id___ko",
    path: "/feed/:id()",
    component: () => import("/codebuild/output/src423944966/src/pages/feed/[id].vue")
  },
  {
    name: "feed-id___en",
    path: "/en/feed/:id()",
    component: () => import("/codebuild/output/src423944966/src/pages/feed/[id].vue")
  },
  {
    name: "feed-id___th",
    path: "/th/feed/:id()",
    component: () => import("/codebuild/output/src423944966/src/pages/feed/[id].vue")
  },
  {
    name: "feed___ko",
    path: "/feed",
    component: () => import("/codebuild/output/src423944966/src/pages/feed/index.vue")
  },
  {
    name: "feed___en",
    path: "/en/feed",
    component: () => import("/codebuild/output/src423944966/src/pages/feed/index.vue")
  },
  {
    name: "feed___th",
    path: "/th/feed",
    component: () => import("/codebuild/output/src423944966/src/pages/feed/index.vue")
  },
  {
    name: "fund-gaudi-fund___ko",
    path: "/fund/gaudi-fund",
    meta: indexGo8QZhSo9kMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/gaudi-fund/index.vue")
  },
  {
    name: "fund-gaudi-fund___en",
    path: "/en/fund/gaudi-fund",
    meta: indexGo8QZhSo9kMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/gaudi-fund/index.vue")
  },
  {
    name: "fund-gaudi-fund___th",
    path: "/th/fund/gaudi-fund",
    meta: indexGo8QZhSo9kMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/gaudi-fund/index.vue")
  },
  {
    name: "fund-gaudi___ko",
    path: "/fund/gaudi",
    meta: gaudidsgGBVy6ehMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/gaudi.vue")
  },
  {
    name: "fund-gaudi___en",
    path: "/en/fund/gaudi",
    meta: gaudidsgGBVy6ehMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/gaudi.vue")
  },
  {
    name: "fund-gaudi___th",
    path: "/th/fund/gaudi",
    meta: gaudidsgGBVy6ehMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/gaudi.vue")
  },
  {
    name: "fund-history___ko",
    path: "/fund/history",
    meta: historywsLh82s6cUMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/history.vue"),
    children: [
  {
    name: "fund-history-id___ko",
    path: ":id()",
    component: () => import("/codebuild/output/src423944966/src/pages/fund/history/[id].vue")
  }
]
  },
  {
    name: "fund-history___en",
    path: "/en/fund/history",
    meta: historywsLh82s6cUMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/history.vue"),
    children: [
  {
    name: "fund-history-id___en",
    path: ":id()",
    component: () => import("/codebuild/output/src423944966/src/pages/fund/history/[id].vue")
  }
]
  },
  {
    name: "fund-history___th",
    path: "/th/fund/history",
    meta: historywsLh82s6cUMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/history.vue"),
    children: [
  {
    name: "fund-history-id___th",
    path: ":id()",
    component: () => import("/codebuild/output/src423944966/src/pages/fund/history/[id].vue")
  }
]
  },
  {
    name: "fund___ko",
    path: "/fund",
    meta: index9QotyrkZlBMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/index.vue"),
    children: [
  {
    name: "fund-index-id___ko",
    path: ":id()",
    component: () => import("/codebuild/output/src423944966/src/pages/fund/index/[id].vue")
  }
]
  },
  {
    name: "fund___en",
    path: "/en/fund",
    meta: index9QotyrkZlBMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/index.vue"),
    children: [
  {
    name: "fund-index-id___en",
    path: ":id()",
    component: () => import("/codebuild/output/src423944966/src/pages/fund/index/[id].vue")
  }
]
  },
  {
    name: "fund___th",
    path: "/th/fund",
    meta: index9QotyrkZlBMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/index.vue"),
    children: [
  {
    name: "fund-index-id___th",
    path: ":id()",
    component: () => import("/codebuild/output/src423944966/src/pages/fund/index/[id].vue")
  }
]
  },
  {
    name: "fund-notice-id___ko",
    path: "/fund/notice/:id()",
    meta: _91id_93N5D0YMVmeWMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/notice/[id].vue")
  },
  {
    name: "fund-notice-id___en",
    path: "/en/fund/notice/:id()",
    meta: _91id_93N5D0YMVmeWMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/notice/[id].vue")
  },
  {
    name: "fund-notice-id___th",
    path: "/th/fund/notice/:id()",
    meta: _91id_93N5D0YMVmeWMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/notice/[id].vue")
  },
  {
    name: "fund-notice___ko",
    path: "/fund/notice",
    meta: index1vI4lQtunWMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/notice/index.vue")
  },
  {
    name: "fund-notice___en",
    path: "/en/fund/notice",
    meta: index1vI4lQtunWMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/notice/index.vue")
  },
  {
    name: "fund-notice___th",
    path: "/th/fund/notice",
    meta: index1vI4lQtunWMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/fund/notice/index.vue")
  },
  {
    name: "hashtag-id___ko",
    path: "/hashtag/:id()",
    meta: _91id_93lQoq2T9LyCMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/hashtag/[id].vue")
  },
  {
    name: "hashtag-id___en",
    path: "/en/hashtag/:id()",
    meta: _91id_93lQoq2T9LyCMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/hashtag/[id].vue")
  },
  {
    name: "hashtag-id___th",
    path: "/th/hashtag/:id()",
    meta: _91id_93lQoq2T9LyCMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/hashtag/[id].vue")
  },
  {
    name: "hashtag___ko",
    path: "/hashtag",
    meta: indexjQ50CX4jCBMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/hashtag/index.vue")
  },
  {
    name: "hashtag___en",
    path: "/en/hashtag",
    meta: indexjQ50CX4jCBMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/hashtag/index.vue")
  },
  {
    name: "hashtag___th",
    path: "/th/hashtag",
    meta: indexjQ50CX4jCBMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/hashtag/index.vue")
  },
  {
    name: "index___ko",
    path: "/",
    meta: indexy4F4jEertZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexy4F4jEertZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/index.vue")
  },
  {
    name: "index___th",
    path: "/th",
    meta: indexy4F4jEertZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/index.vue")
  },
  {
    name: "nova-plus-id___ko",
    path: "/nova-plus/:id()",
    meta: _91id_93fFlgrn9oEhMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/nova-plus/[id].vue")
  },
  {
    name: "nova-plus-id___en",
    path: "/en/nova-plus/:id()",
    meta: _91id_93fFlgrn9oEhMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/nova-plus/[id].vue")
  },
  {
    name: "nova-plus-id___th",
    path: "/th/nova-plus/:id()",
    meta: _91id_93fFlgrn9oEhMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/nova-plus/[id].vue")
  },
  {
    name: "nova-plus___ko",
    path: "/nova-plus",
    meta: index7hLDESftgZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/nova-plus/index.vue")
  },
  {
    name: "nova-plus___en",
    path: "/en/nova-plus",
    meta: index7hLDESftgZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/nova-plus/index.vue")
  },
  {
    name: "nova-plus___th",
    path: "/th/nova-plus",
    meta: index7hLDESftgZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/nova-plus/index.vue")
  },
  {
    name: "oulim___ko",
    path: "/oulim",
    meta: indexCHTWu3LHyUMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/oulim/index.vue")
  },
  {
    name: "oulim___en",
    path: "/en/oulim",
    meta: indexCHTWu3LHyUMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/oulim/index.vue")
  },
  {
    name: "oulim___th",
    path: "/th/oulim",
    meta: indexCHTWu3LHyUMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/oulim/index.vue")
  },
  {
    name: "post-id___ko",
    path: "/post/:id()",
    meta: _91id_93WoBc8bOIqZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/post/[id].vue")
  },
  {
    name: "post-id___en",
    path: "/en/post/:id()",
    meta: _91id_93WoBc8bOIqZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/post/[id].vue")
  },
  {
    name: "post-id___th",
    path: "/th/post/:id()",
    meta: _91id_93WoBc8bOIqZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/post/[id].vue")
  },
  {
    name: "referral-@id___ko",
    path: "/referral/@:id()",
    meta: _64_91id_933Y4ceXmaJwMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/referral/@[id].vue")
  },
  {
    name: "referral-@id___en",
    path: "/en/referral/@:id()",
    meta: _64_91id_933Y4ceXmaJwMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/referral/@[id].vue")
  },
  {
    name: "referral-@id___th",
    path: "/th/referral/@:id()",
    meta: _64_91id_933Y4ceXmaJwMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/referral/@[id].vue")
  },
  {
    name: "search-detail-comment-id___ko",
    path: "/search/detail/comment/:id()",
    meta: _91id_93Lvotf1nEuyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/comment/[id].vue")
  },
  {
    name: "search-detail-comment-id___en",
    path: "/en/search/detail/comment/:id()",
    meta: _91id_93Lvotf1nEuyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/comment/[id].vue")
  },
  {
    name: "search-detail-comment-id___th",
    path: "/th/search/detail/comment/:id()",
    meta: _91id_93Lvotf1nEuyMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/comment/[id].vue")
  },
  {
    name: "search-detail-comment___ko",
    path: "/search/detail/comment",
    meta: indexK0tlu3JdQzMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/comment/index.vue")
  },
  {
    name: "search-detail-comment___en",
    path: "/en/search/detail/comment",
    meta: indexK0tlu3JdQzMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/comment/index.vue")
  },
  {
    name: "search-detail-comment___th",
    path: "/th/search/detail/comment",
    meta: indexK0tlu3JdQzMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/comment/index.vue")
  },
  {
    name: "search-detail-hashtag___ko",
    path: "/search/detail/hashtag",
    meta: hashtag57jddELMijMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/hashtag.vue")
  },
  {
    name: "search-detail-hashtag___en",
    path: "/en/search/detail/hashtag",
    meta: hashtag57jddELMijMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/hashtag.vue")
  },
  {
    name: "search-detail-hashtag___th",
    path: "/th/search/detail/hashtag",
    meta: hashtag57jddELMijMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/hashtag.vue")
  },
  {
    name: "search-detail-index-id___ko",
    path: "/search/detail/:id()",
    meta: _91id_93pRTRcM88nAMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/index/[id].vue")
  },
  {
    name: "search-detail-index-id___en",
    path: "/en/search/detail/:id()",
    meta: _91id_93pRTRcM88nAMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/index/[id].vue")
  },
  {
    name: "search-detail-index-id___th",
    path: "/th/search/detail/:id()",
    meta: _91id_93pRTRcM88nAMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/index/[id].vue")
  },
  {
    name: "search-detail-index___ko",
    path: "/search/detail",
    meta: indexns34CPQrlbMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/index/index.vue")
  },
  {
    name: "search-detail-index___en",
    path: "/en/search/detail",
    meta: indexns34CPQrlbMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/index/index.vue")
  },
  {
    name: "search-detail-index___th",
    path: "/th/search/detail",
    meta: indexns34CPQrlbMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/index/index.vue")
  },
  {
    name: "search-detail-nova-plus-id___ko",
    path: "/search/detail/nova-plus/:id()",
    meta: _91id_93dK2Y1VBKZZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/nova-plus/[id].vue")
  },
  {
    name: "search-detail-nova-plus-id___en",
    path: "/en/search/detail/nova-plus/:id()",
    meta: _91id_93dK2Y1VBKZZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/nova-plus/[id].vue")
  },
  {
    name: "search-detail-nova-plus-id___th",
    path: "/th/search/detail/nova-plus/:id()",
    meta: _91id_93dK2Y1VBKZZMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/nova-plus/[id].vue")
  },
  {
    name: "search-detail-nova-plus___ko",
    path: "/search/detail/nova-plus",
    meta: indexnJ1xH9qc8kMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/nova-plus/index.vue")
  },
  {
    name: "search-detail-nova-plus___en",
    path: "/en/search/detail/nova-plus",
    meta: indexnJ1xH9qc8kMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/nova-plus/index.vue")
  },
  {
    name: "search-detail-nova-plus___th",
    path: "/th/search/detail/nova-plus",
    meta: indexnJ1xH9qc8kMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/nova-plus/index.vue")
  },
  {
    name: "search-detail-user___ko",
    path: "/search/detail/user",
    meta: userOEFf9gfaykMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/user.vue")
  },
  {
    name: "search-detail-user___en",
    path: "/en/search/detail/user",
    meta: userOEFf9gfaykMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/user.vue")
  },
  {
    name: "search-detail-user___th",
    path: "/th/search/detail/user",
    meta: userOEFf9gfaykMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/detail/user.vue")
  },
  {
    name: "search___ko",
    path: "/search",
    meta: index4UCIMGq1raMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/index.vue"),
    children: [
  {
    name: "search-index-id___ko",
    path: ":id()",
    meta: _91id_93EbBweYqwhMMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/index/[id].vue")
  }
]
  },
  {
    name: "search___en",
    path: "/en/search",
    meta: index4UCIMGq1raMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/index.vue"),
    children: [
  {
    name: "search-index-id___en",
    path: ":id()",
    meta: _91id_93EbBweYqwhMMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/index/[id].vue")
  }
]
  },
  {
    name: "search___th",
    path: "/th/search",
    meta: index4UCIMGq1raMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/index.vue"),
    children: [
  {
    name: "search-index-id___th",
    path: ":id()",
    meta: _91id_93EbBweYqwhMMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/search/index/[id].vue")
  }
]
  },
  {
    name: "terms-id___ko",
    path: "/terms/:id()",
    meta: _91id_937WHYmxus8RMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/terms/[id].vue")
  },
  {
    name: "terms-id___en",
    path: "/en/terms/:id()",
    meta: _91id_937WHYmxus8RMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/terms/[id].vue")
  },
  {
    name: "terms-id___th",
    path: "/th/terms/:id()",
    meta: _91id_937WHYmxus8RMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/terms/[id].vue")
  },
  {
    name: "user-id-activities___ko",
    path: "/user/:id()/activities",
    meta: activitiesNcpdNbVdnAMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/activities.vue"),
    children: [
  {
    name: "user-id-activities-postId___ko",
    path: ":postId()",
    meta: _91postId_93mDoG5nJ8WkMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/activities/[postId].vue")
  }
]
  },
  {
    name: "user-id-activities___en",
    path: "/en/user/:id()/activities",
    meta: activitiesNcpdNbVdnAMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/activities.vue"),
    children: [
  {
    name: "user-id-activities-postId___en",
    path: ":postId()",
    meta: _91postId_93mDoG5nJ8WkMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/activities/[postId].vue")
  }
]
  },
  {
    name: "user-id-activities___th",
    path: "/th/user/:id()/activities",
    meta: activitiesNcpdNbVdnAMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/activities.vue"),
    children: [
  {
    name: "user-id-activities-postId___th",
    path: ":postId()",
    meta: _91postId_93mDoG5nJ8WkMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/activities/[postId].vue")
  }
]
  },
  {
    name: "user-id-collections___ko",
    path: "/user/:id()/collections",
    meta: collectionswG6281hYg9Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/collections.vue"),
    children: [
  {
    name: "user-id-collections-collectionId___ko",
    path: ":collectionId()",
    meta: _91collectionId_93dLOPgoEfPcMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/collections/[collectionId].vue")
  }
]
  },
  {
    name: "user-id-collections___en",
    path: "/en/user/:id()/collections",
    meta: collectionswG6281hYg9Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/collections.vue"),
    children: [
  {
    name: "user-id-collections-collectionId___en",
    path: ":collectionId()",
    meta: _91collectionId_93dLOPgoEfPcMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/collections/[collectionId].vue")
  }
]
  },
  {
    name: "user-id-collections___th",
    path: "/th/user/:id()/collections",
    meta: collectionswG6281hYg9Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/collections.vue"),
    children: [
  {
    name: "user-id-collections-collectionId___th",
    path: ":collectionId()",
    meta: _91collectionId_93dLOPgoEfPcMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/collections/[collectionId].vue")
  }
]
  },
  {
    name: "user-id-donation___ko",
    path: "/user/:id()/donation",
    meta: donationqQj8ypW8bIMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/donation.vue")
  },
  {
    name: "user-id-donation___en",
    path: "/en/user/:id()/donation",
    meta: donationqQj8ypW8bIMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/donation.vue")
  },
  {
    name: "user-id-donation___th",
    path: "/th/user/:id()/donation",
    meta: donationqQj8ypW8bIMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/donation.vue")
  },
  {
    name: "user-id-index-postId___ko",
    path: "/user/:id()/:postId()",
    meta: _91postId_93PWjT0iMFzWMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/index/[postId].vue")
  },
  {
    name: "user-id-index-postId___en",
    path: "/en/user/:id()/:postId()",
    meta: _91postId_93PWjT0iMFzWMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/index/[postId].vue")
  },
  {
    name: "user-id-index-postId___th",
    path: "/th/user/:id()/:postId()",
    meta: _91postId_93PWjT0iMFzWMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/index/[postId].vue")
  },
  {
    name: "user-id-index___ko",
    path: "/user/:id()",
    meta: indexDI5ksVrwpHMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/index/index.vue")
  },
  {
    name: "user-id-index___en",
    path: "/en/user/:id()",
    meta: indexDI5ksVrwpHMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/index/index.vue")
  },
  {
    name: "user-id-index___th",
    path: "/th/user/:id()",
    meta: indexDI5ksVrwpHMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/index/index.vue")
  },
  {
    name: "user-id-reward___ko",
    path: "/user/:id()/reward",
    meta: reward2vI28LPZfAMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/reward.vue")
  },
  {
    name: "user-id-reward___en",
    path: "/en/user/:id()/reward",
    meta: reward2vI28LPZfAMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/reward.vue")
  },
  {
    name: "user-id-reward___th",
    path: "/th/user/:id()/reward",
    meta: reward2vI28LPZfAMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/[id]/reward.vue")
  },
  {
    name: "user-sponsors___ko",
    path: "/user/sponsors",
    meta: indexCfqUhDzDBhMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/sponsors/index.vue")
  },
  {
    name: "user-sponsors___en",
    path: "/en/user/sponsors",
    meta: indexCfqUhDzDBhMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/sponsors/index.vue")
  },
  {
    name: "user-sponsors___th",
    path: "/th/user/sponsors",
    meta: indexCfqUhDzDBhMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/user/sponsors/index.vue")
  },
  {
    name: "w3cf-detail-id___ko",
    path: "/w3cf/detail/:id()",
    meta: _91id_93aUgOkUFBS8Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/w3cf/detail/[id].vue")
  },
  {
    name: "w3cf-detail-id___en",
    path: "/en/w3cf/detail/:id()",
    meta: _91id_93aUgOkUFBS8Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/w3cf/detail/[id].vue")
  },
  {
    name: "w3cf-detail-id___th",
    path: "/th/w3cf/detail/:id()",
    meta: _91id_93aUgOkUFBS8Meta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/w3cf/detail/[id].vue")
  },
  {
    name: "w3cf___ko",
    path: "/w3cf",
    meta: indexUvIOAGE16nMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/w3cf/index.vue")
  },
  {
    name: "w3cf___en",
    path: "/en/w3cf",
    meta: indexUvIOAGE16nMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/w3cf/index.vue")
  },
  {
    name: "w3cf___th",
    path: "/th/w3cf",
    meta: indexUvIOAGE16nMeta || {},
    component: () => import("/codebuild/output/src423944966/src/pages/w3cf/index.vue")
  }
]